var allCheckBoxInBox = false;
// Beállítjuk a checkbox értékét oldaltöltéskor, hogy ne legyen undefined
window.checkboxInit = function () {
    $('.checkbox').each(function () {
        if (typeof $(this).data('checked') === 'undefined') {
            if ($(this).hasClass('checked')) {
                $(this).data('checked', 1);
            } else {
                $(this).data('checked', 0);
            }
        }
    });
};

$(function () {
    window.checkboxInit();

    if (!window.checkboxInited) {
        // Ha nincs disable class a checkboxon, akkor click eventre
        $(document).on('click', '.checkbox:not(.disabled)', function (e) {
            // Ha eddig checked volt, 0-ra állítjuk és levesszük a checked classt
            if ($(this).hasClass('checked')) {
                $(this).removeClass('checked').data('checked', 0);
                // És fordítva
            } else {
                $(this).addClass('checked').data('checked', 1);
            }
            // checkbox-change saját eventet triggereljük
            $(this).trigger('checkbox-changed');
        });

        // Ha a táblázat fejlécében a kijelölés megfordítása ikonra kattint, akkor az adott oszlopban megfordítja a kijelölést
        $(document).on('click', '.swap:not(.disabled)', function () {
            var that = $(this),
                table;

            if (allCheckBoxInBox) {
                table = that.parents('.box').find('table');
            } else {
                table = that.parents('table');
            }

            var id = that.parents('th').data('col-index'),
                checked = table.find(
                    `td[data-col-index="${id}"] .checkbox.group.checked`,
                ),
                notChecked = table
                    .find(`td[data-col-index="${id}"] .checkbox.group`)
                    .not('.checked'),
                checkboxCount = table.find(
                    `td[data-col-index="${id}"] .checkbox.group`,
                ).length,
                headCheckbox = table.find(
                    `td[data-col-index="${id}"] .checkbox.group-head`,
                );

            var switching = 0;
            checked.each(function () {
                switching++;
                $(this).data('checked', 0).removeClass('checked');
                if (checkboxCount == switching)
                    headCheckbox.data('checked', 0).removeClass('checked');
            });

            switching = 0;
            notChecked.each(function () {
                switching++;
                $(this).data('checked', 1).addClass('checked');
                if (checkboxCount == switching)
                    headCheckbox.data('checked', 1).addClass('checked');
            });
        });

        $(document).on(
            'checkbox-changed',
            '.checkbox.group-head:not(.disabled)',
            function () {
                var that = $(this),
                    table;

                if (allCheckBoxInBox) {
                    table = that.parents('.box').find('table');
                } else {
                    table = that.parents('table');
                }

                const index = table.find('th').index(that.parents('th')),
                    checks = [],
                    changes = [];

                table.find('tr').each((i, tr) => {
                    checks.push($(tr).children().eq(index).find('.checkbox'));
                });

                if (allCheckBoxInBox) {
                    if (that.data('checked')) {
                        table
                            .find('th')
                            .eq(index)
                            .data('checked', 1)
                            .addClass('checked');
                    } else {
                        table
                            .find('th')
                            .eq(index)
                            .data('checked', 0)
                            .removeClass('checked');
                    }
                }

                checks.forEach((checkbox) => {
                    if (checkbox.data('checked') !== that.data('checked')) {
                        if (that.data('checked')) {
                            checkbox.data('checked', 1).addClass('checked');
                        } else {
                            checkbox.data('checked', 0).removeClass('checked');
                        }
                        changes.push({
                            parent: $(checkbox.parents('td')),
                            value: that.data('checked'),
                        });
                    }
                });

                $(this).trigger('allCheckboxChanged', { changes });
            },
        );

        $(document).on(
            'checkbox-changed',
            '.checkbox.group:not(.disabled)',
            function () {
                var that = $(this),
                    table;

                if (allCheckBoxInBox) {
                    table = that.parents('.box').find('table');
                } else {
                    table = that.parents('table');
                }

                var id = that.parents('td').data('col-index'),
                    checks = table.find(
                        `td[data-col-index="${id}"] .checkbox.group:not(.disabled)`,
                    ),
                    check = table.find(
                        `th[data-col-index="${id}"] .checkbox.group-head`,
                    ),
                    count = 0,
                    checked = 0;

                checks.each(function () {
                    count++;
                    if ($(this).data('checked') === 1) {
                        checked++;
                    }
                });
                if (checked === count) {
                    check.data('checked', 1).addClass('checked');
                } else {
                    check.data('checked', 0).removeClass('checked');
                }

                table[0].dispatchEvent(
                    new CustomEvent('checkbox:changed', {
                        detail: { checkbox: this },
                    }),
                );
            },
        );

        window.checkboxInited = true;
    }
});
